<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getBinFenSeedFarmUserTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">苗场账户列表</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="readOnly ===false"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreateBinFenSeedFarmUser">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :extHeight="60"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getBinFenSeedFarmUserTableRecords" />
                </Col>
            </Row>
        </Card>

        <BinFenSeedFarmUserEdit ref="binfenSeedFarmModal" :departmentList="departmentList" :companyList="companyList" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { approvalFormat, statusFormat } from '@/libs/baseModelFormat';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import BinFenSeedFarmUserEdit from './binFenSeedFarm-user-edit';
import { getBinFenSeedFarmUserList } from '@/api/modules/account-management/binFenSeedFarm-user-management';

export default {
    name: 'BinFenSeedFarmUserList',
    components: {
        SearchCard,
        StandPaginationTable,
        BinFenSeedFarmUserEdit
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        },
        departmentList: {
            type: Array,
            default: () => []
        },
        companyList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 60, align: 'center' },
                    { title: '姓名', key: 'userBinFenSeedFarmName', align: 'center' },
                    { title: '登录账号', key: 'userName', align: 'center' },
                    { title: '关联苗场', key: 'seedFarmName', align: 'center' },
                    { title: '手机号码', key: 'userBinFenSeedFarmPhone', align: 'center' },
                    {
                        title: '审核',
                        key: 'userBinFenSeedFarmApproval',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, approvalFormat(params.row.userBinFenSeedFarmApproval))
                            ]);
                        }
                    },
                    { title: '创建时间', key: 'userBinFenSeedFarmCreateAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.userBinFenSeedFarmCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.onUpdateBinFenSeedFarmUser(params.row);
                                        }
                                    }
                                }, '编辑')
                            ]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '登陆帐号', type: 'Input', value: '', name: 'userName', sql: 'like' },
                    { label: '姓名', type: 'Input', value: '', name: 'userBinFenSeedFarmName', sql: 'like' },
                    { label: '关联苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '审核状态', type: 'Select', name: 'userBinFenSeedFarmApproval', sql: 'in', options: [{ value: 1, key: '通过' }, { value: 0, key: '未通过' }] }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    created() {
        if (this.readOnly) {
            const findIndex = this.mainTable.columns.findIndex(c => c.title === "操作");
            if (findIndex >= 0) {
                this.mainTable.columns.splice(findIndex, 1);
            }
        }
    },
    mounted() {
        this.getBinFenSeedFarmUserTableRecords();
    },
    methods: {
        getBinFenSeedFarmUserTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            getBinFenSeedFarmUserList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onCreateBinFenSeedFarmUser() {
            this.$refs.binfenSeedFarmModal.showModal('');
        },
        onUpdateBinFenSeedFarmUser(binFenSeedFarmUserRow) {
            this.$refs.binfenSeedFarmModal.showModal(binFenSeedFarmUserRow.userBinFenSeedFarmLoginUuid);
        }
        
    }
};
</script>

<style scoped>
</style>
